import axios from 'axios'
import { IMPORTAR_USUARIOS_EMPRESA } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function importarUsuariosEmpresa (codigoEmpresaOrigem, codigoEmpresaDestino) {
  let url = `${URL}/usuarios-empresa/empresa-origem/${codigoEmpresaOrigem}/empresa-destino/${codigoEmpresaDestino}/importar`;
  return dispatch => axios.post(url,SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: IMPORTAR_USUARIOS_EMPRESA,
      payload: response
    })
  );
}
